import { Button, Drawer, Form, Select, Space, Table } from 'antd';
import DouyinAccountCheckButton from './DouyinAccountCheckButton';
import KuaishouAccountCheckButton from './KuaishouAccountCheckButton';
import XhsAccountCheckButton from './XhsAccountCheckButton';
import { getAccountPlatformLabel } from '../utils/accountReadiness';

const TimedPublishAccountDrawer = ({
  open,
  loading,
  accountFilterForm,
  accountDataSource,
  accountPagination,
  selectedAccountKeys,
  onClose,
  onBack,
  onConfirm,
  onFilter,
  onResetFilter,
  onPageChange,
  onPageSizeChange,
  onSelect,
  onSelectAll,
  onSelectionChange,
  getCheckboxProps,
  renderAccountReadinessCell,
}) => (
  <Drawer
    title="创建发布任务-选择发布账号"
    placement="right"
    width={800}
    onClose={onClose}
    open={open}
    mask
    maskStyle={{ backdropFilter: 'none', WebkitBackdropFilter: 'none' }}
    footer={(
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
        <Button onClick={onBack}>返回</Button>
        <Space>
          <Button onClick={onClose}>取消</Button>
          <Button type="primary" onClick={onConfirm} disabled={selectedAccountKeys.length === 0}>
            确认选择 ({selectedAccountKeys.length})
          </Button>
        </Space>
      </div>
    )}
  >
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Form
        form={accountFilterForm}
        layout="inline"
        onFinish={onFilter}
        style={{ marginBottom: 16 }}
      >
        <Form.Item label="平台" name="platforms">
          <Select
            mode="multiple"
            allowClear
            style={{ width: 200 }}
            placeholder="请选择平台"
            options={[
              { label: '微信公众号', value: '微信公众号' },
              { label: '微信视频号', value: '微信视频号' },
              { label: '小红书', value: '小红书' },
              { label: '抖音', value: '抖音' },
              { label: '快手', value: '快手' },
              { label: '百家号', value: '百家号' },
              { label: '知乎', value: '知乎' },
              { label: 'B站', value: 'B站' },
              { label: '今日头条', value: '今日头条' },
            ]}
          />
        </Form.Item>
        <Form.Item label="状态" name="status">
          <Select
            mode="multiple"
            allowClear
            style={{ width: 200 }}
            placeholder="请选择状态"
            options={[
              { label: '活跃', value: 'active' },
              { label: '未激活', value: 'inactive' },
              { label: '已暂停', value: 'suspended' },
            ]}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">筛选</Button>
          <Button style={{ marginLeft: 8 }} onClick={onResetFilter}>重置</Button>
        </Form.Item>
      </Form>

      <Table
        className="account-select-table"
        size="small"
        columns={[
          {
            title: '平台',
            dataIndex: 'platform',
            key: 'platform',
            width: 90,
            render: (_, record) => getAccountPlatformLabel(record),
          },
          {
            title: '账号管理员',
            dataIndex: 'operator_user_names',
            key: 'operator_user_id',
            width: 140,
            ellipsis: true,
            render: (operatorUserNames) => {
              if (Array.isArray(operatorUserNames)) {
                const text = operatorUserNames.join(', ');
                return <span title={text}>{text}</span>;
              }
              return <span title={operatorUserNames || '-'}>{operatorUserNames || '-'}</span>;
            },
          },
          {
            title: '账号名',
            dataIndex: 'account_name',
            key: 'account_name',
            width: 180,
            ellipsis: true,
            render: (accountName) => <span title={accountName || '-'}>{accountName || '-'}</span>,
          },
          {
            title: '账号id',
            dataIndex: 'account_id',
            key: 'account_id',
            width: 140,
            ellipsis: true,
            render: (accountId) => <span title={accountId || '-'}>{accountId || '-'}</span>,
          },
          {
            title: '账号状态',
            key: 'login_readiness',
            width: 260,
            render: (_, record) => renderAccountReadinessCell(record),
          },
          {
            title: '检测',
            key: 'account_check',
            width: 220,
            render: (_, record) => (
              <Space size="small">
                <DouyinAccountCheckButton account={record} label="检测" buttonProps={{ style: { padding: '0 4px' } }} />
                <KuaishouAccountCheckButton account={record} label="检测" buttonProps={{ style: { padding: '0 4px' } }} />
                <XhsAccountCheckButton account={record} label="检测" restartMcp buttonProps={{ style: { padding: '0 4px' } }} />
              </Space>
            ),
          },
        ]}
        dataSource={accountDataSource}
        rowKey="account_id"
        loading={loading}
        rowSelection={{
          selectedRowKeys: selectedAccountKeys,
          preserveSelectedRowKeys: true,
          getCheckboxProps,
          onSelect,
          onSelectAll,
          onChange: onSelectionChange,
        }}
        pagination={{
          current: accountPagination.current,
          pageSize: accountPagination.pageSize,
          total: accountPagination.total,
          showTotal: (total) => `共 ${total} 条记录`,
          showSizeChanger: true,
          showQuickJumper: true,
          onChange: onPageChange,
          onShowSizeChange: onPageSizeChange,
        }}
        scroll={{ x: 'max-content' }}
      />
    </Space>
  </Drawer>
);

export default TimedPublishAccountDrawer;
